module.exports = __webpack_public_path__ + "7dcf3d435cd63f3c7d997ee2f05676e7.MP3";